<template>
    <div class="members">
        <transition-group name="flip-list" tag="ul" class="list-group">
            <li class="list-group-item position-relative member" :class="{ 'member-active': member.active }"
                v-for="member in this.members" :key="member.id">

                <div class="avatar">
                    <img :class="{ host: member.host }" :src="member.avatar" alt="Avatar" />
                    <i v-if="member.host" class="fas fa-crown host-icon"></i>
                </div>

                <div class="name">
                    {{ member.name }}
                </div>

                <div class="vote">
                    <span v-if="member.vote === true">
                        <i class="far fa-check text-success"></i>
                    </span>

                    <span v-else-if="member.vote !== null && member.vote !== false" class="font-weight-bold">
                        {{ member.vote }}
                    </span>

                    <span v-else-if="state">
                        <i class="fal fa-spinner-third fa-spin"></i>
                    </span>

                    <span v-else>
                        <i class="fal fa-snooze text-info"></i>
                    </span>
                </div>
            </li>
        </transition-group>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            sorted: false
        }
    },
    computed: {
        members() {
            let members = this.$store.state.game.members.map((member) => {
                member.active = !!this.$store.state.channel.presence.find(client => client.id === member.id);
                member.vote = this.$store.state.game.votes[member.id] || null;
                member.host = this.$store.state.game.host_id === member.id;
                return member;
            });

            return this.sorted
                ? members.sort((a, b) => {
                    const aVote = a.vote === '?' ? -1 : parseFloat(a.vote);
                    const bVote = b.vote === '?' ? -1 : parseFloat(b.vote);

                    return bVote - aVote;
                })
                : members;
        },
        ...mapState({
            state: state => state.game.state
        })
    },
    created() {
        this.$store.watch((state) => state.game.state, (newValue) => {
            if (newValue === 0) {
                setTimeout(() => {
                    this.sorted = true;
                }, 1000)
            } else {
                this.sorted = false;
            }
        });
    },
    mounted() {
        this.sorted = !this.state;
    }
}
</script>

<style lang="scss" scoped>
.flip-list-move {
    transition: transform 1s;
}

.member {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .avatar {
        margin-right: 10px;

        img {
            width: 35px;
            border-radius: 50%;
            margin: -8px 0 -7px 0;
        }

        .host-icon {
            top: 0;
            left: 19px;
            position: absolute;
            color: goldenrod;
            font-size: 14px;
            transform: rotate(329deg);
        }
    }

    .name {
        flex-grow: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &.member-active {
        .name {
            font-weight: bold;
        }
    }
}
</style>
